import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const status = createReducer(ActionTypes.USER_LOGIN_CHECK_UNKNOWN, {
  [ActionTypes.USER_LOGIN_CHECK_SUCCESS]: (state, { type }) => type
});

const passwordStatus = createReducer(null, {
  [ActionTypes.SET_PASSWORD_SUCCESS]: (state, { type }) => type,
  [ActionTypes.SET_PASSWORD_ERROR]: (state, { type }) => type
});

const connectFacebookStatus = createReducer(null, {
  [ActionTypes.FACEBOOK_CONNECT_SUCCESS]: (state, { type }) => type
});

const data = createReducer(null, {
  [ActionTypes.USER_LOGIN_CHECK_SUCCESS]: (state, { payload }) => ({ ...state, ...payload }),
  [ActionTypes.USER_SET_ID]: (state, { payload }) => ({ ...state, user_id: payload }),
  [ActionTypes.USER_LOGIN_ERROR]: (state, { payload }) => ({ ...state, login_error: payload })
});

const token = createReducer(
  { value: null },
  {
    [ActionTypes.USER_LOGIN_CHECK_SUCCESS]: (state, { payload }) => ({
      value: payload.jwt || state.value
    }),
    [ActionTypes.USER_SET_JWT]: (state, { payload }) => ({
      value: payload
    })
  }
);

const signUp = createReducer(
  {
    success: false,
    message: {
      message: '',
      field: ''
    },
    errorInfo: {}
  },
  {
    [ActionTypes.USER_SIGNUP_ERROR]: state => ({
      ...state,
      success: false
    }),
    [ActionTypes.USER_SIGNUP_SUCCESS]: state => ({
      ...state,
      success: true
    }),
    [ActionTypes.USER_SIGNUP_ERROR_INFO]: (state, { payload }) => ({
      ...state,
      errorInfo: payload
    }),
    [ActionTypes.USER_SIGNUP_MESSAGE]: (state, { payload }) => {
      return {
        ...state,
        message: payload
      };
    }
  }
);

export default combineReducers({
  signUp,
  status,
  passwordStatus,
  connectFacebookStatus,
  data,
  token
});
